import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Dialog, LinkButton } from 'rc-easyui';


import { setStatusValue } from '../../actions/Project/ProjectListAction';

import { setIsShowFindAllViewList} from '../../actions/transOperationActions';

import { setIsShowFindAllViewInput,setIsShowFindAllViewReplace} from '../../actions/transOperation_find_Actions';
import { showFindPositionAndAlign} from '../../actions/findActions';
import { showHidePositionList,setFindPositionTargetData} from '../../actions/find/positionFindAction';


class FindPositionAlignView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value:11,
            errors: {}
        };
        this.setFindBlue = this.setFindBlue.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
    }

    async closeDialog() {
        this.props.showFindPositionAndAlign(false);
    }

    async componentDidMount() {
        await this.setState({ value: this.props.project.statusValue });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors });
        }

        // if (nextProps.findOperation) {
        //     const isPositionAlignDialog = nextProps.findOperation.isPositionAlignDialog;
        //     if(isPositionAlignDialog === true){
        //         this.positionAligndlg.open();
        //     }
        // }
    }


    async setFindBlue(result) {
        this.props.showFindPositionAndAlign(result);
    }



    render() {

        const {data} = this.props.editTable;

        return <div
            title="Find Position and Align"
            style={{width:'450px' }}
            ref={ref=>this.positionAligndlg=ref}
        >
            <h3>Find Position and Align</h3>
            <form  className=' '  >
                <div className="form-check">
                    {/*<input className="form-check-input" type="checkbox" value="" id="defaultCheck1" checked />*/}
                    <label className="form-check-label" htmlFor="defaultCheck2">
                        Position
                    </label>
                </div>
                <div className="form-check">
                    {/*<input className="form-check-input" type="checkbox" value="" id="defaultCheck2" checked/>*/}
                    <label className="form-check-label" htmlFor="defaultCheck2">
                        Align
                    </label>
                </div>

                <div style={{marginBottom:'20px',marginTop:'20px'}}>
                    <LinkButton  onClick={() => {
                        this.closeDialog(true);


                        //搜尋
                        let newTarget = [];
                        data.map( (ROWoBJ,index)=> {
                            // console.log(`搜尋資料 ${ROWoBJ.Position}`);
                            if(ROWoBJ.Position !== ''){

                                // console.log(`搜尋資料 ${ROWoBJ.Position}`);
                                newTarget.push({type:"Position",rowIndex:index,position:ROWoBJ.Position});
                            }
                        });
                        this.props.setFindPositionTargetData(newTarget);

                        //顯示結果
                        this.props.showList();
                    }} >Find</LinkButton>
                </div>
            </form>

            <hr/>
            <div className=' '>
                <LinkButton style={{ width: 80 }} onClick={() => this.closeDialog(true)}  >Close</LinkButton>
            </div>
        </div>;
    }
}


FindPositionAlignView.propTypes = {
    errors: PropTypes.object.isRequired,
    project: PropTypes.object.isRequired,
    setIsShowFindAllViewInput: PropTypes.func.isRequired,
    multipleFind: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    project: state.project,
    errors: state.errors,
    transOperation: state.transOperation,
    findOperation: state.findOperation,
    editTable: state.editTable
});

export default connect(mapStateToProps, { setStatusValue,
    setIsShowFindAllViewInput,
    setIsShowFindAllViewList ,
    setIsShowFindAllViewReplace,
    showFindPositionAndAlign,
    showHidePositionList,
    setFindPositionTargetData})(
    withRouter(FindPositionAlignView)
);



// WEBPACK FOOTER //
// ./src/components/multipleFind/FindPositionAlignView.js